import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import {
  verifyPublishCoupon,
  getCouponValue,
} from '../../../app/Helper/CouponHelper';

function CouponText({ coupons, isPartnerDisplay }) {
  const value = getCouponValue(coupons);
  const { isRepresentCoupon } = coupons.couponDisplaySummary;
  const getCouponText = () => {
    return (
      <Fragment>
        <span className="coupon_price">
          {!isRepresentCoupon && '최대'} {value}
        </span>{' '}
        {isPartnerDisplay ? '할인쿠폰 더 받기' : '할인쿠폰 받기'}
      </Fragment>
    );
  };

  return (
    <span className="coupon_text">
      {verifyPublishCoupon(coupons) ? '할인쿠폰 발급완료' : getCouponText()}
    </span>
  );
}

CouponText.propType = {
  coupons: PropTypes.shape({}),
  isPartnerDisplay: PropTypes.bool,
};

export default CouponText;
